import { generateId } from '@freelancer/datastore/testing/helpers';
import { isDefined } from '@freelancer/utils';
import type {
  BidVectorSearchAnnotation,
  BidVectorSearchAnnotationSegment,
} from './bid-vector-search-annotations.model';

export interface GenerateBidVectorSearchAnnotationOptions {
  readonly id?: number;
  readonly bidId?: number;
  readonly projectId?: number;
  readonly text?: string;
  readonly segments?: readonly BidVectorSearchAnnotationSegment[];
}

export interface GenerateBidVectorSearchAnnotationsOptions {
  readonly projectId: number;
  readonly bidIds: readonly number[];
  readonly annotations: readonly Exclude<
    GenerateBidVectorSearchAnnotationOptions,
    'id'
  >[];
}

export function generateBidVectorSearchAnnotationObject({
  id = generateId(),
  bidId = generateId(),
  projectId = generateId(),
  text = 'Has a strong portfolio and excellent reviews.',
  segments = [
    {
      text: 'strong portfolio',
      context: {
        id: 1,
        type: 'showcase',
      },
    },
  ],
}: GenerateBidVectorSearchAnnotationOptions): BidVectorSearchAnnotation {
  return {
    id,
    bidId,
    projectId,
    text,
    segments,
  };
}

export function generateBidVectorSearchAnnotationObjects({
  projectId,
  bidIds,
  annotations,
}: GenerateBidVectorSearchAnnotationsOptions): readonly BidVectorSearchAnnotation[] {
  return bidIds
    .map((bidId, index) => {
      const annotation = annotations.at(index);

      if (annotation === undefined) {
        return undefined;
      }

      return generateBidVectorSearchAnnotationObject({
        projectId,
        bidId,
        ...annotation,
      });
    })
    .filter(isDefined);
}
